import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {ListGroupAndUserResponse} from "it/primatoo/openapi/api/org/schemas/capability/ListGroupAndUserResponse";
import {ListCapabilityResponse} from "it/primatoo/openapi/api/org/schemas/capability/ListCapabilityResponse";

@Injectable({
  providedIn: 'root'
})
export class CapabilitiesService {

  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient) {
    this.endpoint = this.config.endPoint + '/api/org/v2/capabilities/';
  }

  findUserAndUsersGroups(): Observable<ListGroupAndUserResponse> {
    const url = `${this.endpoint}users-and-user-groups/`;
    return this.httpClient.get<ListGroupAndUserResponse>(url);
  }

  findCapabilities(): Observable<ListCapabilityResponse> {
    const url = `${this.endpoint}`;
    return this.httpClient.get<ListCapabilityResponse>(url);
  }
}
